import type { LinkProps } from 'react-router-dom';

import { Link } from 'react-router-dom';
import React from 'react';

import type { Routes } from '../../router';

// ----------------------------------------------------------------------

const RouterLink = React.forwardRef<
  HTMLAnchorElement,
  { replace?: boolean; to: Routes } & LinkProps
>(({ replace, to, ...other }, ref) => (
  <Link replace={replace} ref={ref} {...other} to={to} />
));

RouterLink.displayName = 'RouterLink';
export default RouterLink;
